import type { VariableResponse, Variable } from '../types/variables';
import { APIClient } from './apiClient';
import { VL_API_BASE_URL } from 'vince-core/constants/backendUrls';

const baseUrl = `${VL_API_BASE_URL}/v1/variables`;

export async function loadVariables () {
    const response = await APIClient<string>(`${baseUrl}/`);
    return JSON.parse(response);
}

export async function getVariableById (variableId: string) {
    const response = await APIClient<string>(`${baseUrl}/${variableId}`);
    return JSON.parse(response);
}

export async function createVariable (variableData: Partial<Variable>) {
    return await APIClient<VariableResponse>(`${baseUrl}/`, { 
        method: 'POST', 
        body: JSON.stringify(variableData) 
    });
}

export async function updateVariable (variableData: Partial<Variable>) {
    return await APIClient<VariableResponse>(`${baseUrl}/${variableData.variableId}`, { 
        method: 'PUT', 
        body: JSON.stringify(variableData) 
    });
}

export async function deleteVariable (variableId: string): Promise<void> {
    await APIClient(`${baseUrl}/${variableId}`, { method: 'DELETE' });
}
